var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showAllOption
        ? _c("div", [
            _c("input", {
              attrs: {
                id: _vm.fieldName + "-option-all",
                type: "checkbox",
                name: _vm.fieldName
              },
              domProps: { value: null },
              on: {
                click: function($event) {
                  return _vm.reset()
                }
              }
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                class: [
                  {
                    selected: !_vm.checkedValues.length
                  }
                ],
                attrs: { for: _vm.fieldName + "-option-all" }
              },
              [_vm._v(_vm._s(_vm.dctxt("all")))]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.options, function(option, index) {
        return _c(
          "div",
          {
            key: _vm.fieldName + "-option-all",
            class: ["dc-post-grid-dropdown-option-wrapper"]
          },
          [
            _c("input", {
              attrs: {
                id: _vm.fieldName + "-option-" + option.value,
                type: "checkbox",
                name: _vm.fieldName
              },
              domProps: {
                value: option.value,
                checked: _vm.checkedValues.includes(option.value)
              },
              on: {
                click: function($event) {
                  return _vm.choose(option.value, option.label)
                }
              }
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                class: [
                  {
                    selected: _vm.checkedValues.includes(option.value)
                  }
                ],
                attrs: { for: _vm.fieldName + "-option-" + option.value }
              },
              [_vm._v(_vm._s(option.label))]
            )
          ]
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }